import type { InjectionKey } from 'vue'

export interface NewContactInput {
  readonly name: string
  readonly notes?: string
}

export type ContactCreateResult =
  | { readonly ok: true; readonly accountId: string; readonly name: string }
  | { readonly ok: false; readonly detail: string | undefined }

/** Creates a contact in the active ledger and resolves once the target list includes it. */
export interface ContactCreator {
  readonly enabled: () => boolean
  create(input: NewContactInput): Promise<ContactCreateResult>
}

export const CONTACT_CREATOR_KEY: InjectionKey<ContactCreator> = Symbol('taler.contactCreator')
